/**
 *
 * PluginIcon
 *
 */

import React from 'react';
export const FlashcardsPluginIcon = () => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "800px",
    height: "800px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2C14.3284 2 15 2.67157 15 3.5V5H0V3.5C0 2.67157 0.671573 2 1.5 2H13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6V11.5C0 12.3284 0.671573 13 1.5 13L13.5 13C14.3284 13 15 12.3284 15 11.5V6H0ZM2 10H8V9H2V10ZM13 10H10V9H13V10Z"
  }));
};